import React from "react";
import MDBox from "../components/MDBox";
import MDTypography from "../components/MDTypography";


export default function ErrorPage() {  
  return (
      <MDBox alignItems="center">
          <center>
          <MDBox mt={2}>
              <MDTypography variant="h1" fontWeight="medium">
                 404
              </MDTypography>
          </MDBox>
          <MDBox mt={2}>
              <MDTypography variant="h2" fontWeight="regular">
                  age not found :(
              </MDTypography>
          </MDBox>
          <MDBox mt={2}>
              <MDTypography variant="h4" fontWeight="light">
                  Ooooups! Looks like you got lost.
              </MDTypography>
              </MDBox>
              </center>
      </MDBox>
  );
}
